import React from 'react';
import { Link } from 'react-router-dom';
import { Monitor, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Monitor className="h-7 w-7 text-blue-400" />
              <div className="flex flex-col">
                <span className="text-lg font-bold text-white">Microworld Solution</span>
                <span className="text-xs text-gray-400">Inc.</span>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              Your trusted partner for comprehensive computer support, software solutions, and enterprise security.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-blue-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/#support" className="text-sm hover:text-blue-400 transition-colors">
                  Support Services
                </Link>
              </li>
              <li>
                <Link to="/#pricing" className="text-sm hover:text-blue-400 transition-colors">
                  Pricing Plans
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-sm hover:text-blue-400 transition-colors">
                  Shop Computers
                </Link>
              </li>
              <li>
                <Link to="/antivirus" className="text-sm hover:text-blue-400 transition-colors">
                  Antivirus Software
                </Link>
              </li>
              <li>
                <Link to="/sonicwall" className="text-sm hover:text-blue-400 transition-colors">
                  SonicWall Firewalls
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li className="text-sm">Computer & Laptop Support</li>
              <li className="text-sm">Software Installation</li>
              <li className="text-sm">Antivirus Solutions</li>
              <li className="text-sm">Hardware Sales</li>
              <li className="text-sm">Network Security</li>
              <li className="text-sm">Remote Support</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-sm">
                <Phone className="h-4 w-4 text-blue-400" />
                <a href="tel:+18449742333" className="hover:text-blue-400">+1-844-974-2333</a>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Mail className="h-4 w-4 text-blue-400" />
                <a href="mailto:microworldsolutioninc@gmail.com" className="hover:text-blue-400">microworldsolutioninc@gmail.com</a>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <MapPin className="h-4 w-4 text-blue-400 mt-0.5" />
                <div>
                  <p className="font-semibold text-white mb-1">USA Office:</p>
                  <p>9609 W 164th ST<br />Overland Park, Stillwell<br />Kansas 66083, USA</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Microworld Solution Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;